import { render } from "./draftList.vue?vue&type=template&id=457b8077"
import script from "./draftList.vue?vue&type=script&lang=js"
export * from "./draftList.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__